import { Stack } from '@mui/material';
import React from 'react';
import IndividualPerfomanceChart from '../IndvidualPerfomanceChartSection/IndividualPerfomanceChart';

export default function IndividualChartLanding() {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} gap={1}>
      <IndividualPerfomanceChart />
      <IndividualPerfomanceChart sales />
    </Stack>
  );
}
